import React from "react";
import { Link } from "react-router-dom";
import { BRANDING, CATEGORY_DECK } from "@/branding";
import { Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-20 bg-plum-deep text-cream" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10 text-sm">
        <div className="col-span-2">
          <div className="flex items-baseline gap-2">
            <Sparkles className="h-4 w-4 text-gold" />
            <div className="font-serif-display text-2xl text-cream">{BRANDING.storeName}</div>
          </div>
          <p className="text-cream/70 mt-3 max-w-sm leading-relaxed">
            {BRANDING.tagline}
          </p>
          <p className="mt-5 text-xs text-cream/50">Original digital products you can download instantly. Made with care, delivered the moment you check out.</p>
        </div>
        <div>
          <div className="font-medium mb-3 text-gold">Shop</div>
          <ul className="space-y-2 text-cream/70">
            <li><Link to="/shop" className="hover:text-cream">All products</Link></li>
            <li><Link to="/shop?featured=1" className="hover:text-cream">Featured</Link></li>
            <li><Link to="/shop?new=1" className="hover:text-cream">New releases</Link></li>
            <li><Link to="/shop?bestseller=1" className="hover:text-cream">Best sellers</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3 text-gold">Categories</div>
          <ul className="space-y-2 text-cream/70">
            {CATEGORY_DECK.slice(0, 6).map((c) => (
              <li key={c.slug}><Link to={`/shop?category=${c.slug}`} className="hover:text-cream">{c.name}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 text-center md:flex md:items-center md:justify-between gap-3">
          <div className="text-xs text-cream/60">© {new Date().getFullYear()} {BRANDING.storeName}. All rights reserved.</div>
          <div className="text-xs text-cream/50 mt-2 md:mt-0">
            <Link to="/about" className="hover:text-cream">About</Link>
            <span className="mx-2">·</span>
            <Link to="/admin/login" className="hover:text-cream" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
